package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.data.analytics.FirebaseAnalyticsDataSource
import com.eladfinish.bible.contest.data.analytics.FirebaseAnalyticsDataSourceImpl
import com.eladfinish.bible.contest.data.remoteConfig.FirebaseRemoteConfigDataSource
import com.eladfinish.bible.contest.data.remoteConfig.FirebaseRemoteConfigDataSourceImpl
import com.eladfinish.bible.contest.screens.browse.usecases.BuildChapterListUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetBooksSelectionUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.ParseSedarimUseCase
import com.eladfinish.bible.contest.screens.mikud.MikudRepository
import com.eladfinish.bible.contest.utils.GetParashotUseCase
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val dataModule = module {
    includes(dataPlatformModule)
    singleOf(::MikudRepository)

    includes(assetsPlatformModule)
    singleOf(::GetParashotUseCase)
    singleOf(::ParseSedarimUseCase)
    singleOf(::BuildChapterListUseCase)
    singleOf(::GetBooksSelectionUseCase)

    single<FirebaseRemoteConfigDataSource> {
        FirebaseRemoteConfigDataSourceImpl(
            firebaseRemoteConfig = getOrNull(),
        )
    }

    single<FirebaseAnalyticsDataSource> {
        FirebaseAnalyticsDataSourceImpl()
    }
}
